<h1 class="text-center border-bottom pb-3">
  Nieuwe verkooporder voor klant
  <a
    href="{{ indiCustomer.icmLinkID | icmCustomerLink }}"
    target="_blank"
  >
    {{ indiCustomer.customerNumber }}
  </a>
</h1>

<div *ngIf="APIVerkooporder.createdOrderNumber">
  <app-new-salesorder-duplicate-verkooporder
    [verkooporderIds]="APIVerkooporder.createdOrderNumber"
    [amountOfVerkooporders]="ids.length"
  >
  </app-new-salesorder-duplicate-verkooporder>
</div>

<div *ngIf="isLoading">
  <app-loading-gears></app-loading-gears>
</div>

<div
      *ngIf="feedbackSettings.show"
    >
  <div class="feedback_box">
    <app-feedback
      [(settings)]="feedbackSettings"
      (update)="toOverview()"
    ></app-feedback>
  </div>
</div>

<div *ngIf="orderError">
  <app-orderline-errors
    [error]="orderError"
    (closeError)="hideOrderError()"
  ></app-orderline-errors>
</div>

<div [ngClass]="{'d-none': isLoading || feedbackSettings.show || apiResponse || APIVerkooporder.createdOrderNumber }">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="needs-validation">
    <app-new-salesorder-orderlines
      [orderlines]="orderlines"
    ></app-new-salesorder-orderlines>

    <div class="d-flex mt-3">
      <div class="w-50">
        <app-new-salesorder-info
          [info]="info"
          [freshdeskTicketNumbers]="ticketIds"
        ></app-new-salesorder-info>
        <div class="mt-5">
          {{ icmNote }}
        </div>
      </div>

      <div class="w-50">
        <app-new-salesorder-shipping-details
          [shippingDetails]="shippingDetails"
          [deliveryAddress]="APIVerkooporder.orderDetails.deliveryAddress"
          [addresses]="shippingAddresses"
          [users]="users"
          [nightShippingAddress]="nightShippingAddress"
          [hasNightShipping]="indiCustomer.hasNightshipping"
          [hasPickUpAtCounter]="indiCustomer.hasPickUpAtCounter ?? false"
          (invoiceEmailChanged)="handleInvoiceEmailChange($event)">
        ></app-new-salesorder-shipping-details>
        <br />
        <app-new-salesorder-invoice-details
          [invoiceDetails]="invoiceDetails"
          [invoiceEmailAddress]="invoiceEmailAddress">
        ></app-new-salesorder-invoice-details>
      </div>
    </div>

    <div class="d-flex gap-5 mt-4">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="
          !orderlinesComponent?.valid ||
          !shippingComponent?.valid ||
          !invoiceComponent?.valid ||
          !infoComponent?.valid
        "
      >
        <i class="fa-regular fa-shopping-cart fa-lg"></i> Verkooporder aanmaken
      </button>

      <button
        class="btn btn-danger"
        (click)="markVerkoopordersAsManuallyCreated()"
        [disabled]="manuallyCreatedIsLoading"
      >
        <ng-container *ngIf="!manuallyCreatedIsLoading; else loading">
          <i class="fa-solid fa-pen-ruler fa-lg"></i>
          {{
            ids.length > 1
              ? "Deze verkooporders zijn handmatig aangemaakt"
              : "Deze verkooporder is handmatig aangemaakt"
          }}
        </ng-container>
        <ng-template #loading>
          <i class="fa-solid fa-spinner fa-spin fa-lg"></i>
        </ng-template>
      </button>
    </div>
  </form>
</div>

<div *ngIf="apiResponse">
  <app-new-salesorder-sent
    [response]="apiResponse"
  ></app-new-salesorder-sent>
</div>
